import { get } from "lodash";
import { connect } from "react-redux";

import { InvoiceListPage } from "../Invoices/InvoiceListPage";
import { INTERNAL_RESOURCE_TYPE, INVOICE_SERVICES } from "../Invoices/constants";
import { getPaging } from "../../reducers/resources.reducer";

export class InternalInvoiceListPage extends InvoiceListPage {
  title = "Internal Invoices";
  resourceType = INTERNAL_RESOURCE_TYPE;
  isInternalInvoice = true;
  invoicesService = INVOICE_SERVICES.INTERNAL_INVOICES;
}

const mapStateToProps = state => ({
  tenantSlug: get(state, "common.currentTenant.slug"),
  postPaymentsActive: get(state, "common.currentTenant.postPaymentsActive", false),
  isDeliveryEnabled: get(state, "common.currentTenant.deliveryEnabled", false),
  totalResourceNumber: get(state, "resources.totalResourceNumber"),
  listOfAllInvoicesIdOnly: get(state, "resources.listOfAllResourceIdOnly", []),
  isFetchingInProgress: get(state, "resources.isFetchingInProgress", false),
  isBackendProcessingOngoing: get(state, "resources.isBackendProcessingOngoing", false),
  invoicingFrequency: get(state, "common.currentTenant.invoicePeriodSize"),
  isNetsuiteApiImportEnabled: get(state, "common.currentTenant.netsuiteApiImport", false),
  paging: getPaging(state)
});

export default connect(mapStateToProps)(InternalInvoiceListPage);
